import {handleAddToCartAndSyncApp} from "../../common/appShoppingCart";
import {useOverlay} from "../../common/step0Overlay";

class WarenkorbButtonVis extends HTMLElement {
    static get observedAttributes() {
        return ["data-state"];
    }

    connectedCallback() {
        this.declareElements();

        if (this.isApp === true) {
            this.setSubmitListener();
        }
        if (this.isApp != true) {
            const artikelnummer = this.getAttribute("artikel-nummer");
            useOverlay(this, artikelnummer);
        }
    }

    attributeChangedCallback(attributename, oldValue, newValue) {
        if (oldValue === newValue) {
            return;
        }
        if (attributename === "data-state") {
            this.changeButtonState(newValue);
        }
    }

    declareElements() {
        this.isApp = (this.getAttribute("is-app") === "true");
        this.form = this.querySelector("form");
        this.artikelnummern = this.getArtikelnummern();
    }

    setSubmitListener() {
        this.form.addEventListener("submit", (event) => handleAddToCartAndSyncApp(event, this.artikelnummern));
    }

    getArtikelnummern() {
        const artikelnummern = this.getAttribute("artikel-nummer");
        let artikelnummernArray = artikelnummern.split(',');
        return artikelnummernArray;
    }

    changeButtonState(newState) {
        const wkButton = this.querySelector("button");

        if (newState === "loading") {
            const backupWkButtonContent = wkButton.innerHTML;
            wkButton.setAttribute("disabled", "");
            wkButton.querySelector(".element-icon-warenkorb-hinzufuegen").classList.toggle("hide");
            wkButton.setAttribute("data-loading","");
            this.resetButtonState(wkButton, backupWkButtonContent, 5000, true)
        } else if (newState === "success") {
            const backupWkButtonContent = wkButton.innerHTML;
            wkButton.removeAttribute("disabled");
            wkButton.removeAttribute("data-loading");
            wkButton.innerHTML = `<span class="element-icon-checkmark"></span>Im Warenkorb`;
            this.resetButtonState(wkButton, backupWkButtonContent, 2000);
        }
    }

    resetButtonState(wkButton, backupContent, time, hardreset = false) {
        setTimeout(() => {
            if (hardreset) {
                wkButton.removeAttribute("disabled");
                wkButton.removeAttribute("data-loading");
            }
            wkButton.innerHTML = backupContent;
            wkButton.querySelector(".element-icon-warenkorb-hinzufuegen").classList.remove("hide");
        }, time);
    }
}

if (!customElements.get("warenkorb-button-vis")) {
  customElements.define("warenkorb-button-vis", WarenkorbButtonVis);
}
